module.exports = (__webpack_require__(15))(7);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/moment/moment.js from dll-reference vendor_library
// module id = 23
// module chunks = 0